import React from 'react';
import {
  Typography,
  FlexBox,
  Listbox,
  ListboxButton,
  ListboxPopover,
  ListboxList,
  ListboxOption,
} from '@vp/swan';

import PropTypes from 'prop-types';
import { useTranslations } from '@vp/om-translations';
import { getQuantitySelectionValues } from '../util/quantityHelper';

const QuantitySelector = ({
  activeQuantity,
  merchandisableQuantities,
  updateQuantityFn,
  selectorDisabled,
  cartItemId,
}) => {
  const [cartMessages] = useTranslations(['cartMessages']);
  const quantityText = cartMessages.quantity;

  const quantities = getQuantitySelectionValues({
    activeQuantity,
    merchandisableQuantities,
  });

  // If multiple quantities exist, display dropdown
  if (quantities && quantities.length > 1) {
    return (
      <FlexBox alignItems="center">
        <Listbox
          size="mini"
          value={`${activeQuantity}`}
          selectionMode="single"
          disabled={selectorDisabled}
          onChange={val => {
            // only "update the quantity" if the selected value was not undefined
            // temporary measure while clicking a selected item unselects it
            // https://vistaprint.atlassian.net/browse/DSYS-3258
            if (val !== undefined) updateQuantityFn(val);
          }}
        >
          <ListboxButton
            labelPrefix={quantityText}
            placeholder={cartMessages.selectAQuantity}
          />
          <ListboxPopover>
            <ListboxList aria-label={`quantity-label-${cartItemId}`}>
              {quantities.map(selectableQuantity => (
                <ListboxOption key={selectableQuantity}>
                  {/* this must be a string */}
                  {`${selectableQuantity}`}
                </ListboxOption>
              ))}
            </ListboxList>
          </ListboxPopover>
        </Listbox>
      </FlexBox>
    );
  }

  // If merchandisableQuantities only has 1 value (the activeQuantity), display read only value
  return (
    <FlexBox alignItems="center">
      <Typography component="label" marginRight="2">
        {quantityText} {activeQuantity}
      </Typography>
    </FlexBox>
  );
};

QuantitySelector.propTypes = {
  merchandisableQuantities: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.number),
    range: PropTypes.arrayOf(
      PropTypes.shape({
        minimum: PropTypes.number,
        maximum: PropTypes.number,
        increment: PropTypes.number,
      })
    ),
  }),
  activeQuantity: PropTypes.number.isRequired,
  updateQuantityFn: PropTypes.func.isRequired,
  selectorDisabled: PropTypes.bool.isRequired,
  cartItemId: PropTypes.string.isRequired,
};

export default QuantitySelector;
